import React, { useEffect, useState } from 'react';
import { Button, Form, message } from 'antd';
import { FiDatabase, FiDownload } from 'react-icons/fi';
import fileDownload from 'js-file-download';
import { useGenericMutation } from '../../../../queries/use-generic-mutation';
import useDownloadFile from '../../../../services/useDownloadFile';
import CommonCard from '../../../global/card';
import CommonForm from '../../../global/form';
import SOURCES from '../../../../utils/constants';
import Spinner from '../../../global/spinner';

const EnhanceDatabaseBacktup = () => {
    const [form] = Form.useForm();
    const [zipFileName, setZipFileName] = useState("");

    // Mutation to verify security code and generate backup
    const verifySecurityCodeMutation = useGenericMutation({
        endpoint: 'admin/database/backup',
        onSuccess: (data) => {
            message.success("Database Backup Generated Successfully");
            setZipFileName(data); // Assuming data returns the filename as per old logic
        },
        onError: (err) => {
            const status = err?.response?.status;
            const backendError = err?.response?.data?.error;

            if (status === 403) {
                message.error(backendError || "Invalid Security Code");
                return;
            }

            message.error(backendError || "Failed to generate backup");
        }
    });

    // Hook to download the file
    const { callApi: callDownload, data: downloadedFile } = useDownloadFile({
        endpoint: `admin/database/backup?fileName=${zipFileName}`,
    });

    useEffect(() => {
        if (downloadedFile) {
            fileDownload(downloadedFile, "leadsimport.zip");
        }
    }, [downloadedFile]);

    const handleFinish = async (values) => {
        try {
            await verifySecurityCodeMutation.mutateAsync({
                securityCode: values.securityCode
            });
        } catch (err) {
            console.log(err)
        }
    };

    const handleDownload = async () => {
        if (!zipFileName) return;
        await callDownload();
    };

    const formData = [
        {
            label: "Security Code",
            name: "securityCode",
            type: "password",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            required: true,
            placeholder: "Enter Your Security Code Here...",
            span: 12,
            message: "Security Code is required",
        }
    ];

    return (
        <CommonCard
            className="shadow-xl border-none overflow-hidden"
        >
            <div className="p-2">
                <CommonForm
                    form={form}
                    data={formData}
                    onFinish={handleFinish}
                />

                <div className="flex flex-wrap items-center gap-4 mt-2 pt-6 border-t border-gray-100">
                    {zipFileName && (
                        <Button
                            onClick={handleDownload}
                            className="h-10 px-6 font-semibold transition-all flex items-center gap-2 bg-primary/5 text-primary border-primary/20 hover:!bg-primary/10 hover:!border-primary/20"
                        >
                            <FiDownload className="mr-2" />
                            Download Backup
                        </Button>
                    )}
                    <Button
                        type="primary"
                        onClick={() => form.submit()}
                        className="!bg-primary text-white h-10 min-w-[130px]"
                    >
                        {verifySecurityCodeMutation.isPending ? <Spinner className={"!border-white"} /> : <FiDatabase className="mr-2" />}
                        Generate Backup
                    </Button>

                </div>
            </div>
        </CommonCard>
    );
};

export default EnhanceDatabaseBacktup;